import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as Request from "../entries/common/request";
import { BaseApi } from "../core/base-api";
import { makeMethod } from "../core/base-api/methods-maker";
import { createCommentsApiClass } from "./_partials/comments";
var ChatroomCommentsApi = createCommentsApiClass({
  basePath: Request.Chatrooms.Paths.ChatroomId
});
export var ChatroomsApi = /*#__PURE__*/function (_BaseApi) {
  _inherits(ChatroomsApi, _BaseApi);

  var _super = _createSuper(ChatroomsApi);

  function ChatroomsApi(config) {
    var _this;

    _classCallCheck(this, ChatroomsApi);

    _this = _super.call(this, config);
    _this.comments = void 0;
    _this.comments = new ChatroomCommentsApi(config);
    return _this;
  }

  return ChatroomsApi;
}(BaseApi);
/**
 * Show chatroom info
 */

ChatroomsApi.prototype.show = makeMethod({
  method: 'get',
  path: Request.Chatrooms.Paths.ChatroomId
});